import Button from '@orn/shared-web/components/Button/Button';
import { MenuIcon } from '@orn/shared-web/icons';
import { cx } from '@orn/shared-web/utils/cx';
import { Link as RouterLink } from 'react-router-dom';

import { PATHS } from '../../paths';
import MantleHorizontalLockupPrimary from '../logos/MantleHorizontalLockupPrimary';

import { MOBILE_TOP_BAR_HEIGHT_PX } from './dimensions';
import NotificationBellButton from './NotificationBellButton';

interface IMobileTopBarProps {
  /** Invoked when the user taps the hamburger button. */
  onOpenDrawer: () => void;
  /**
   * When `true`, render the alerts bell left of the hamburger. Caller is
   * responsible for resolving the `feat-alerts-center` gate.
   */
  showAlertsBell?: boolean;
  /** Unread alert count shown on the bell's pip. */
  alertsUnreadCount?: number;
  /** Whether the alerts route is the active one. */
  isAlertsCurrent?: boolean;
  /** Opens the Notification Center in place; a modified click on the bell still follows its href. */
  onOpenAlerts?: () => void;
  /** Additional CSS classes to apply. */
  className?: string;
}

/**
 * Fixed top-of-viewport bar shown below the `md` breakpoint in place of the
 * sidebar. Hosts the Mantle wordmark, an optional alerts bell, and a
 * hamburger button that opens the mobile nav drawer.
 */
const MobileTopBar = ({
  onOpenDrawer,
  showAlertsBell = false,
  alertsUnreadCount = 0,
  isAlertsCurrent = false,
  onOpenAlerts,
  className,
}: IMobileTopBarProps) => {
  return (
    <div
      style={{ height: MOBILE_TOP_BAR_HEIGHT_PX }}
      className={cx(
        'bg-app border-secondary fixed inset-x-0 top-0 z-40 flex items-center justify-between border-b px-4',
        className
      )}
    >
      <RouterLink
        to={PATHS.DASHBOARD}
        aria-label="Mantle home"
        className="outline-focus-ring flex h-8 items-center rounded-md transition-opacity hover:opacity-80 focus-visible:outline-2 focus-visible:outline-offset-2"
      >
        <MantleHorizontalLockupPrimary className="h-8 w-auto max-w-[88px]" aria-hidden="true" />
      </RouterLink>
      <div className="flex items-center gap-0.5">
        {showAlertsBell && (
          <NotificationBellButton unreadCount={alertsUnreadCount} current={isAlertsCurrent} onOpen={onOpenAlerts} />
        )}
        <Button aria-label="Open menu" color="tertiary" iconLeading={MenuIcon} onClick={onOpenDrawer} />
      </div>
    </div>
  );
};

export default MobileTopBar;
